class Filters {

    constructor() {

        /**
         * General settings
         */
        this.filterUrlPrefix = 'filters-'; // Prefisso che serve per riconoscere i filtri nel'url query

        this.namespace      = Shopfilters.settings.namespace ? Shopfilters.settings.namespace : 'customFilter';  // Serve per avere degli eventi ad-hoc per i filtri
        this.perPage        = parseInt(Shopfilters.settings.perPage);                                            // Indica quanti prodotti mostrare per pagina
        this.filterMaxPages = parseInt(Shopfilters.settings.filterMaxPages);                                     // Indica il numero totale di pagine della collection/search
        this.tagsMaxPages   = parseInt(Shopfilters.settings.tagsMaxPages);                                       // Indica il numero totale di pagine per ottonere i filtri

        /**
         * Variables
         */

        this.initialFiltersTag     = [];     // Tags totali dei prodotti della collection/search
        this.products              = [];     // Prodotti totali della collection/search
        this.pages                 = [];     // Array contentente le pagine con gli oggetti dei prodotti della collection/search
        this.currentPage           = 1;      // Indica il numero dell'ultima pagina di prodotti caricata in frontend e può prendere il valore ?page=n dell'url nelle collection
        this.pagination            = 1;      // indica il numero di pagina di Shopify
        this.requestedPage         = 1;      // pagina richiesta in url
        this.sorting               = false;  // Indica il sort attuale
        this.onInit                = true;   // Indica se l'init è concluso o meno
        this.filteredProducts      = [];     // Array contentente tutti i prodotti attualmente visibili a frontend
        this.filteredProductsPages = [];     // Array contentente tutti i prodotti attualmente visibili a frontend divisi per pagine
        this.pid                   = false;  // Indica l'id dell'ultimo prodotto su cui si è cliccato, così da ritornare allo stesso prodotto in caso di reload
        this.lastProductPrinted    = 0;      // Indica l'indice dell'ultimo prodotto stampato a video

        this.clothingsizeType  = Shopfilters.settings.sizesFilter.clothing;
        this.shoesizeType      = Shopfilters.settings.sizesFilter.shoes;
        this.accessorysizeType = Shopfilters.settings.sizesFilter.accessories;
        this.priceType         = Shopfilters.settings.priceFilter;

        // Identifica il primo filtro selezionato dall'utente.
        // Il primo filtro selezionato è quello su cui è possibile fare operazioni di multi - choice anche se non possibili, quindi avrà sempre tutte le checkbox cliccabili.
        // Es: se si seleziona 'nero' tra i filtri 'colore', senza una logica particolare, l'utente non potrà filtrare per un altro colore,
        // in quanto solitamente un prodotto ha una sola tipologia di colore.
        this.firstFilterType = false;

        // Identifica il filtro corrente selezionato e visualizzato dall'utente
        this.currentFilterType = false;

        // Esclusiva SJ: Indica la stringa inserita dall'utente nel momento in cui ricerca un brand dentro la dropdown e il suo selettore

        this.searchBrand         = '';
        this.searchBrandSelector = '.filter-search';

        // Esclusiva SJ: il filtro type (category) in SJ deve essere organizzato in livelli, considerando micro e macro category dei prodotti e non solo micro category
        this.filtersCategoryHierarchical = {};

        /**
         * Views
         */

        this.tagsView     = Shopfilters.tagsView ? Shopfilters.tagsView : 'ajax-tags';              // serve per costruire l'array dei tag
        this.productsView = Shopfilters.productsView ? Shopfilters.productsView : 'ajax-products';  // serve per costruire l'array dei prodotti

        /**
         * Filters
         */

        this.initialFilters = Shopfilters.settings.filters;
        this.filters        = [];

        this.url = Shopfilters.settings.isSearch ? '/search' : Shopfilters.settings.url;

        /**
         * Search
         */

        this.q            = Shopfilters.settings.q;                                                 // query della search
        this.productType  = 'product';
        this.articleType  = 'article';
        this.articlesView = Shopfilters.articlesView ? Shopfilters.articlesView : 'ajax-articles';  // serve per costruire l'array degli articoli
        this.activeClass  = 'active';
        this.articlePages = [];
        this.articles     = [];

        this.showProductsSelector             = this.showProductsSelector ? this.showProductsSelector : '.search-show-products';
        this.showArticlesSelector             = this.showArticlesSelector ? this.showArticlesSelector : '.search-show-articles';
        this.articlesListingSelector          = this.articlesListingSelector ? this.articlesListingSelector : '#shop-articles';
        this.articlesListingContainerSelector = this.articlesListingContainerSelector ? this.articlesListingContainerSelector : '.collection-template--articles';
        this.productsListingContainerSelector = this.productsListingContainerSelector ? this.productsListingContainerSelector : '.collection-template--products';

        /**
         * Size mapping (Esclusiva SJ)
         */

        //N.B il size mapping è stato pensato per funzionare solamente per la taglie calzature
        this.sizeMapping = [];

        // vado a pulire il sizemapping preservando newlines, etc
        Shopfilters.settings.sizeMapping = Shopfilters.settings.sizeMapping.replace(/\\n/g, "\\n");
        // remove non-printable and other non-valid JSON chars
        Shopfilters.settings.sizeMapping = Shopfilters.settings.sizeMapping.replace(/[\u0000-\u0019]+/g,"");

        this.sizeMappingMetafield = Shopfilters.settings.sizeMapping ? JSON.parse(Shopfilters.settings.sizeMapping) : [];

        this.sizeMappingOptions = this.sizeMappingOptions ? this.sizeMappingOptions : [
            {'label': 'EUR', 'value': 'eur'},
            {'label': 'US',  'value': 'us'},
            {'label': 'UK',  'value': 'uk'}
        ];

        this.selectedSizeMapping                  = this.sizeMappingOptions[1].value;
        this.sizeMappingSelectSelector            = this.sizeMappingSelectSelector ? this.sizeMappingSelectSelector : '#size-mapping';
        this.sizeMappingFakeSelectSelector        = this.sizeMappingFakeSelectSelector ? this.sizeMappingFakeSelectSelector : '.size-mapping-fake';
        this.sizeMappingFakeSelectSelectorTrigger = this.sizeMappingFakeSelectSelectorTrigger ? this.sizeMappingFakeSelectSelectorTrigger : '.size-mapping-fake__title';
        this.sizeMappingFakeOptionSelector        = this.sizeMappingFakeOptionSelector ? this.sizeMappingFakeOptionSelector : '.size-mapping-fake__option';
        this.sizeMappingSelectOpenClass           = this.sizeMappingSelectOpenClass ? this.sizeMappingSelectOpenClass : 'size-mapping-open';

        // Indica il simbolo da utilizzare per fare lo split sulle taglie calzatura, le quali contengono anche la scala taglia di riferimento.
        // Inizialmente avevo usato '-', ma l'ho modificato perchè ci sono taglie con '-' e questo dava problemi allo split
        this.shoeSizeSeparator = '$';

        /**
         * Common HTML selectors
         */

        this.productsListingSelector = this.productsListingSelector ? this.productsListingSelector : '#shop-products';
        this.loadMoreSelector        = this.loadMoreSelector ? this.loadMoreSelector : '.load-more';
        this.paginationSelector      = this.paginationSelector ? this.paginationSelector : '.pagination-wrapper .pagination';
        this.loaderSelector          = this.loaderSelector ? this.loaderSelector : '.loading-wrapper';
        this.sortingSelector         = this.sortBySelector ? this.sortBySelector : '.sorting';
        this.sortBySelector          = this.sortBySelector ? this.sortBySelector : '.sort-by';
        // Selettore per il contatore dei prodotti trovati filtrando
        this.totalProductsSelector = this.totalProductsSelector ? this.totalProductsSelector : '.filter__container .total-products';
        // Selettore per il contatore dei prodotti trovati filtrando
        this.totalProductsSelectorMobile = this.totalProductsSelectorMobile ? this.totalProductsSelectorMobile : '.filter-mobile__container .total-products';

        this.productCardSelector = this.productCardSelector ? this.productCardSelector : '.product-card';

        // selettore del div dei filtri
        this.filterWrappers       = this.filterWrappers ? this.filterWrappers : '.shop-filters'
        this.filterWrappersMobile = this.filterWrappersMobile ? this.filterWrappersMobile : '.filter-mobile__container .shop-filters'

        // selettore del title di un filtro
        this.filterTypeSelector      = '.filter-type';
        this.filterTypeTitleSelector = '.filter-type__title';

        // selettore di un singolo filtro
        this.filterLinkSelector = this.filterLinkSelector ? this.filterLinkSelector : '.filter-option';

        // selettore in cui mostrare i filtri attualmente in uso
        this.currentFiltersSelector      = this.currentFiltersSelector ? this.currentFiltersSelector : '.current-filters';
        this.currentFilterSelectorMobile = this.currentFilterSelectorMobile ? this.currentFilterSelectorMobile : '.filter-mobile__container .current-filters';

        // selettore per il reset dei filtri
        this.clearFiltersSelector = this.clearFiltersSelector ? this.clearFiltersSelector : '#clear-filters';

        // indica le schiere taglie scritte nel customize. le schiere taglie vengono utilizzate per ordinare correttamente i filtri a frontend
        this.sizesRangeClothing  = Shopfilters.settings.sizesRangeClothing;
        this.sizesRangeShoe      = Shopfilters.settings.sizesRangeShoe;
        this.sizesRangeAccessory = Shopfilters.settings.sizesRangeAccessory;
        this.priceRanges         = Shopfilters.settings.priceRanges;

        this.initEventHandlers();
        this.customInitEventHandlers();
        this.dispatchEvent('onInit');
        this.init();
    }

    init() {
        let $self           = this;
        let promiseTags     = this.getTags();
        let promiseProducts = this.getProducts();
        let promiseArticles = [];
        // let promiseArticles = Shopfilters.settings.isSearch ? this.getArticles() : [];

        // Quando ho sia tags che prodotti, inizializzo i filtri
        Promise.all([promiseTags, promiseProducts, promiseArticles]).then(function() {
            // $self.sortProducts();
            $self.initFilters();
        });

        // Dico al browser di evitare di mantenermi lo scroll totale dopo il back
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }
    }

    dispatchEvent(event, data) {
        data ? window.dispatchEvent(new CustomEvent(this.namespace + '-' + event, {
            detail: data
        })) : window.dispatchEvent(new CustomEvent(this.namespace + '-' + event))
    }

    formatTags() {
        let filterTags = [];
        let formatFilterTags = {};

        for (let i = 0; i < this.initialFiltersTag.length; i++) {
            filterTags = filterTags.concat(this.initialFiltersTag[i]);
        }

        filterTags = filterTags.unique();

        for (let i = 0; i < filterTags.length; i++) {
            let splittedFilterTag = filterTags[i].split('_');

            let tag_type = splittedFilterTag[0];
            let tag_label = splittedFilterTag[1];

            // Se la tipologia del tag è tra quelle incluse in quelle da mostrare e non è un tag con cui costruiamo il sistema di filtraggio delle collection
            if (this.initialFilters.find(initialFilter => initialFilter.type === tag_type) ||
                tag_type == Shopfilters.settings.categoryFilter.microCategory ||
                tag_type == Shopfilters.settings.categoryFilter.macroCategory ||
                tag_type == Shopfilters.settings.categoryFilter.department
            ) {
                if (!formatFilterTags[tag_type]) {
                    formatFilterTags[tag_type] = [];
                }

                formatFilterTags[tag_type].push({
                    type: tag_type, // tipologia del tag
                    tag: tag_label, // valore del tag
                    disabled: false // indica se il filtro a frontend deve essere disabled
                });
            }
        };

        this.initialFiltersTag = formatFilterTags;

        // Custom SJ (serve solamente con visualizzare graficamente il filtro category)
        this.initialFiltersTag['category'] = [];
    }

    getTags() {
        let $self = this;

        return new Promise(function(resolve) {
            let callsCount = $self.tagsMaxPages;
            let promises = [];

            const ajaxCall = (url) => {

                return new Promise(function (resolve) {
                    fetch(url).then(function (response) {

                        return response.json();
                    }).then(function (data) {
                        for (let j = 0; j < data.tags.length; j++) {
                            $self.initialFiltersTag.push(data.tags[j]);
                        }

                        resolve(data);
                    }).catch(function (error) {
                        console.log(error);
                    });
                });
            };

            for (var i = 0; i < callsCount; i++) {
                let url = location.origin + $self.url + '?view=' + $self.tagsView + '&page=' + (i + 1) +
                    ($self.q ? ('&q=' + $self.q + '*') : '') + ($self.productType ? '&type=' + $self.productType : '');

                promises.push(ajaxCall(url));
            };

            Promise.all(promises).then(function() {
                $self.formatTags();
                $self.dispatchEvent('onTagsFetched');
                resolve();
            });
        });
    }

    getProducts() {
        let $self = this;

        return new Promise(function(resolve) {
            let callsCount = $self.filterMaxPages;
            let promises = [];

            const ajaxCall = (url) => {

                return new Promise(function(resolve) {
                    fetch(url)
                        .then(function(response) {
                            // Successfull fetch return as json
                            return response.json();
                        }).then(function(data) {

                            if(data.collectionSortBy) {
                                $self.sorting = data.collectionSortBy;
                            }
                            if (data.products.length > 0) {
                                let products = data.products;

                                // Trasformo filterData in un array multidimensionale di filtri per avere un'alberatura di corretta di department, macro category e micro category
                                for (let j = 0; j < data.products.length; j++) {
                                    let filterDataArray = [];
                                    // Incude gestione esclusiva SJ per il filtro 'category' che può essere rimossa per altri progetti
                                    if (products[j].filterData) {
                                        let dept = false;
                                        let macroCategory = false;
                                        let microCategory = false;

                                        products[j].filterData.map(function(filterTag, index) {
                                            let splittedFilterTag = filterTag.split('_');
                                            if (filterDataArray[splittedFilterTag[0]]) {
                                                filterDataArray[splittedFilterTag[0]].push(splittedFilterTag[1]);
                                            } else {
                                                filterDataArray[splittedFilterTag[0]] = [];
                                                filterDataArray[splittedFilterTag[0]].push(splittedFilterTag[1]);
                                            }

                                            if (splittedFilterTag[0] == Shopfilters.settings.categoryFilter.microCategory) {
                                                microCategory = splittedFilterTag[1];
                                            } else if (splittedFilterTag[0] == Shopfilters.settings.categoryFilter.macroCategory) {
                                                macroCategory = splittedFilterTag[1];
                                            } else if (splittedFilterTag[0] == Shopfilters.settings.categoryFilter.department) {
                                                dept = splittedFilterTag[1];
                                            }
                                        });

                                        // Costruisco l'array dei filtri type con tre livelli
                                        if (macroCategory && microCategory && dept) {
                                            if (!$self.filtersCategoryHierarchical[dept]) {
                                                $self.filtersCategoryHierarchical[dept] = {};
                                                $self.filtersCategoryHierarchical[dept][macroCategory] = [];
                                            }

                                            if (!$self.filtersCategoryHierarchical[dept][macroCategory]) {
                                                $self.filtersCategoryHierarchical[dept][macroCategory] = [];
                                                $self.filtersCategoryHierarchical[dept][macroCategory].push(microCategory);
                                            } else if ($self.filtersCategoryHierarchical[dept][macroCategory] && !$self.filtersCategoryHierarchical[dept][macroCategory].includes(microCategory)) {
                                                $self.filtersCategoryHierarchical[dept][macroCategory].push(microCategory);
                                            }
                                        }
                                    }

                                    products[j].filterData = filterDataArray;
                                }

                                $self.pages[data.page] = products;
                            }
                            resolve(data);
                    }).catch(function(error) {
                        console.log(error);
                    });
                });
            };

            for (let i = 0; i < callsCount; i++) {
                let url = location.origin + $self.url + '?view=' + $self.productsView + '&page=' + (i + 1) +
                    ($self.q ? ('&q=' + $self.q + '*' + '&options[prefix]=last') : '') + ($self.productType ? '&type=' + $self.productType : '');

                promises.push(ajaxCall(url));
            };

            Promise.all(promises).then(function() {
                // Dopo aver fatto tutte le chiamate, riempio l'array contenente tutti i prodotti della collection/search. Le pagine partono da 1
                let position = 0;

                for (let i = 1; i < $self.pages.length; i++) {
                    let products = [];

                    for (let j = 0; j < $self.pages[i].length; j++) {
                        let product = $self.pages[i][j];

                        product.position = position++; // serve per il sorting trending (quello iniziale)
                        products.push(product);
                    }

                    $self.products = $self.products.concat(products);
                }

                $self.dispatchEvent('onProductsFetched');
                resolve();
            });
        });
    }

    getArticles() {
        let $self = this;

        return new Promise(function(resolve) {
            let promises = [];
            let callsCount = $self.filterMaxPages;

            const ajaxCall = (url) => {
                return new Promise(function (resolve) {
                    fetch(url).then(function(response) {
                    return response.json();
                    }).then(function(data) {
                        if (data.articles && data.articles.length > 0) {
                            $self.articlePages[data.page] = data.articles;
                        }

                        resolve(data);
                    }).catch(function(error) {
                        console.log(error);
                    });
                });
            };

            for (let i = 0; i < callsCount; i++) {
                let url = location.origin + $self.url + '?view=' + $self.articlesView + '&page=' + (i + 1) +
                    ($self.q ? ('&q=' + $self.q + '&options[prefix]=last') : '') + ($self.articleType ? '&type=' + $self.articleType : '');

                promises.push(ajaxCall(url));
            };

            Promise.all(promises).then(function() {
                // Dopo aver fatto tutte le chiamate, creo l'array con tutti gli articoli

                for (let i = 0; i < $self.articlePages.length; i++) {
                    if ($self.articlePages[i]) {
                        for (let j = 0; j < $self.articlePages[i].length; j++) {
                            // nascondo gli hidden cam
                            if (!$self.articlePages[i][j].url.includes('hidden-cam')) {
                                $self.articles.push($self.articlePages[i][j]);
                            }
                        }
                    }
                }

                resolve();
            });
        });
    }

    /**
     * Filters logic
     */

    /* Inizializza il sistema filtri */
    initFilters() {
        let $self = this;
        // Controllo se trovo nel localStorage il primo filtro selezionato, che ci servirà per ricreare correttamente l'html dei filtri
        if (localStorage.getItem('filter-first')) {
            this.firstFilterType = !localStorage.getItem('filter-first') || localStorage.getItem('filter-first') == 'false' ? false : localStorage.getItem('filter-first');
        }

        // Inizializzo l'array dei filtri in cui mantengo i filtri attualmente selezionati
        $self.initialFilters.forEach(function(filter, index) {
            if (filter.type) {
                $self.filters[filter.type] = [];

                // Controllo se ci sono filtri della tipologia corrente nell'url
                if (getUrlParameter($self.filterUrlPrefix + filter.type)) {
                    let urlParams = getUrlParameter($self.filterUrlPrefix + filter.type).split(',');

                    // Aggiorno l'array dei fltri con i filtri nell'url
                    for (let j = 0; j < urlParams.length; j++) {
                        $self.updateFilterObject(filter.type, urlParams[j]);
                    }
                }
            }
        });

        // Controllo se ci sono sorting nell'url
        if (getUrlParameter('custom-sort-by')) {
            // Ordino i prodotti
            this.sorting = getUrlParameter('custom-sort-by');
            this.sortProducts();
        } else {
            // eventuale set di un sorting iniziale
        }

        // Controllo se c'è il paramentre se_tab che mi indica che l'utente ha cliccato sul more degli articoli nella search preview
        if (getUrlParameter('se_tab')) {
            this.handleHiglight('articles');
        }

        this.currentPage   = parseInt(getUrlParameter('page')) ?       parseInt(getUrlParameter('page')) :       this.currentPage;
        this.pagination    = parseInt(getUrlParameter('pagination')) ? parseInt(getUrlParameter('pagination')) : this.pagination;
        this.requestedPage = parseInt(getUrlParameter('page')) ?       parseInt(getUrlParameter('page')) :       this.requestedPage;

        this.sortFilters();
        this.executeFilters();
        this.onInit = false;
        this.dispatchEvent('onInitEnded');
    }

    executeFilters() {
        let $self = this;

        let productToRemove = [];

        this.dispatchEvent('onFiltersUpdating');

        this.fetchPages();

        this.products.forEach(function(product, productIndex) {
            let countProductFilter = 0;
            let countFilters = 0;

            Object.keys($self.filters).map(function(filterType) {
                // Controllo che il prodotto che sto analizzando abbia tutti i tag selezionati dall'utente
                if ($self.checkFilter(product, filterType)) {
                    countProductFilter++;
                }

                // Conto quante tipologie di filtri ci sono
                countFilters++;
            });

            // Se per ogni tipologia di tag, il prodotto ha tutti i tag selezionati dal cliente (o nessuno perchè non ci sono tag attivi), lo mostro,
            // altrimenti segno l'id del prodotto nei prodotti che poi andranno rimossi a frontend
            if (countProductFilter != countFilters) {
                // Segno in un array l'indice del prodotto da eliminare
                productToRemove.push(productIndex);
            }
        });

        // Rimuovo i prodotti da eliminare da quelli visibili a frontend
        this.filteredProducts = $self.products.filter(function(product, index) {
            return !productToRemove.includes(index);
        });

        // Gestione grafica del disabled dei filtri
        this.disableFilters();

        this.impaginaFiltrati();

        // Faccio lo scroll top ad ogni modifica di filtro.
        // window.scrollTo(0, 0);
        // if(document.getElementById('PageContainer'))
        // document.getElementById('PageContainer').scrollTop = 0;

        this.dispatchEvent('onFiltersUpdated', {
            product: this.filteredProducts,
            filters: this.filters,
            sorting: this.sorting
        });
    }

    checkFilter(product, type) {
        let $self = this;

        // Se per la tipologia di tag non ci sono tag attivi, il prodotto per quella tipologia di tag, si può considerare visibile.
        if (!this.filters[type].length > 0) return true;

        if(this.sizeMappingMetafield.length == 0) {
            for (let i = 0; i < this.filters[type].length; i++) {
                // Per fare il check se un prodotto deve essere visibile o meno a seconda del tag selezionato, utilizzo la funzione handleize.
                // Questo ci permette di mantenere il valore corretto del tag e anche di evitare i problemi dovuti a controlli su tag con valori contenenti spazi o caratteri speciali
                let formattedFilterData = product.filterData[type] ? product.filterData[type].map(tag => handleize(tag)) : null;
                // Se all'interno dei tag del prodotto trovo il filtro selezionato, allora il prodotto è visibile
                if (formattedFilterData && formattedFilterData.includes(handleize($self.filters[type][i]))) {
                    return true;
                }
            }
        } else {
            if (type != this.shoesizeType) {
                for (let i = 0; i < this.filters[type].length; i++) {
                    // Per fare il check se un prodotto deve essere visibile o meno a seconda del tag selezionato, utilizzo la funzione handleize.
                    // Questo ci permette di mantenere il valore corretto del tag e anche di evitare i problemi dovuti a controlli su tag con valori contenenti spazi o caratteri speciali
                    let formattedFilterData = product.filterData[type] ? product.filterData[type].map(tag => handleize(tag)) : null;

                    // Se all'interno dei tag del prodotto trovo il filtro selezionato, allora il prodotto è visibile
                    if (formattedFilterData && formattedFilterData.includes(handleize($self.filters[type][i]))) {
                        return true;
                    }
                }
            } else {
                // Per il size mapping occorre fare un ragionamento diverso rispetto a tutti gli altri filtri.
                // Un prodotto è visibile se le taglie calzatura selezionate dall'utente nei filtri sono presenti come corrispondenze nel suo size mapping.
                // Es: un cliente seleziona 4US. Devo capire se nel size mapping del prodotto esiste una corrispondenza con 4US, che potrebbe essere 3.5UK, 35 EUR etc...
                for (let i = 0; i < this.filters[type].length; i++) {
                    if (product.filterData[type] && product.sizeMappingId) {
                        // Trovo il size mapping del prodotto all'interno del metafield
                        let currentSizeMapping = this.sizeMappingMetafield.find(sizeMapping => sizeMapping.id == parseInt(product.sizeMappingId));
                        let splittedTag = this.filters[type][i].split($self.shoeSizeSeparator);

                        if (currentSizeMapping && splittedTag[0]) {
                            // Trovo le riga nel size mapping relativa alla taglia che sto analizzando
                            let sizeMappingRows = currentSizeMapping.size.filter(size => size[splittedTag[1]].toString().toLowerCase() == splittedTag[0].toLowerCase());

                            if (sizeMappingRows.length > 0) {
                                // Analizzo la riga del mapping per capire se ho una corrispondenza
                                for (let j = 0; j < sizeMappingRows.length; j++) {
                                    for (const [key, value] of Object.entries(sizeMappingRows[j])) {
                                        // Praticamente, un prodotto è visibile se:
                                        // 1) la scala taglia che sto analizzando (key) è uguale a quella del filtro e trovo nei tag del prodotto il valore della taglia (value);
                                        // 2) la scala taglia che sto analizzando (key) è uguale al defaultSizeScale del prodotto e trovo nei tag del prodotto il valore della taglia (value);
                                        if ((key == splittedTag[1] && product.filterData[type].includes(value.toLowerCase())) || (key == product.defaultSizeScale && product.filterData[type].includes(value.toLowerCase()))) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                    // Nel caso in cui un prodotto non abbia il sizeMappingId, ma solo la scala taglia di riferimento, allora devo comunque mostrare il prodotto
                    // se il cliente ha selezionato un filtro di una taglia footwear che il prodotto ha, considerando anche il defaultSizeScale.
                    // Es: un cliente seleziona 4US, se analizzando tutti i prodotti trovo un prodotto che ha tag 'size-footwear_4' e il defaultSizeScale 'US'
                    // allora il prodotto deve essere mostrato anche se non ha il size mapping.
                    } else if (product.defaultSizeScale && product.filterData[this.shoesizeType]) {
                        let defaultSizeScale = product.defaultSizeScale.toLowerCase();

                        for (let i = 0; i < this.filters[type].length; i++) {
                            let formattedFilterData = product.filterData[type] ? product.filterData[type].map(tag => handleize(tag)) : null;
                            let splittedTag = $self.filters[type][i].split(this.shoeSizeSeparator);

                            // Se all'interno dei tag del prodotto trovo il filtro selezionato, allora il prodotto è visibile
                            if (formattedFilterData && defaultSizeScale == splittedTag[1] && formattedFilterData.includes(handleize(splittedTag[0]))) {
                                return true;
                            }
                        }
                    }
                }
            }
        }

        return false;
    }

    // Permette di disabilitare al frontend tutti i filtri che portano ad un 'not found' se applicati.
    // Si potrebbe ottimizzare leggermente.
    disableFilters() {
        let $self = this;

        if (this.countActiveFilters() > 0) {
            if ($self.countActiveFilters() == 1) {
                // Se ho un solo filtro attivo, la tipologia di questo filtro diventa quella iniziale, usata per definire i disabled
                Object.keys(this.filters).map(function(filterType) {
                    if ($self.filters[filterType].length > 0) {
                        $self.firstFilterType = filterType;
                    }
                });
            }

            // Metto tutti i filtri a disabled = false, tranne quelli del filtro iniziale che sono sempre tutti selezionabili
            Object.keys(this.initialFiltersTag).map(function(initialFilterType) {
                for (let i = 0; i < $self.initialFiltersTag[initialFilterType].length; i++) {
                    $self.initialFiltersTag[initialFilterType][i].disabled = initialFilterType != $self.firstFilterType ? true : false;
                }
            });

            // Metto tutti i filtri footwear a disabled = false, tranne quando il filtro iniziale è proprio quello per i footwear
            Object.keys($self.sizeMapping).map(function(key) {
                for (let i = 0; i < $self.sizeMapping[key].length; i++) {
                    if ($self.sizeMapping[key][i].disabled != undefined) {
                        $self.sizeMapping[key][i].disabled = $self.shoesizeType != $self.firstFilterType ? true : false;
                    }
                }
            });

            // Il check per capire se uno dei filtri iniziali è disabled deve partire sempre controllando i tag di tutti i prodotti e non solo di quelli filtered,
            // perchè in quelli filtered già sono stati applicati i filtri
            // La logica applicata è simile quella del filtraggio (checkFilter), ma su tutti i prodotti.
            $self.products.map(function(product) {
                let testFilters = [];

                for (const [initialFilterType, initialFilterTypeArray] of Object.entries($self.initialFiltersTag)) {
                    let filterTypeTags = initialFilterTypeArray.map(initialFilterTag => handleize(initialFilterTag.tag));

                    // Prendo i prodotti che soddisfano le condizioni dei filtri selezionati dal cliente
                    Object.keys($self.filters).map(function(filterKey) {
                        testFilters[filterKey] = false;

                        if ($self.filters[filterKey].length > 0) {
                            let formattedFilters = $self.filters[filterKey].map(filter => handleize(filter));
                            let formattedFilterData = product.filterData[filterKey] ? product.filterData[filterKey].map(tag => handleize(tag)) : null;

                            if (filterKey != $self.shoesizeType) {
                                if (formattedFilterData && (formattedFilterData.filter(element => formattedFilters.includes(element)).length > 0 || formattedFilterData.filter(element => filterTypeTags.includes(element)).length > 0)) {
                                    testFilters[filterKey] = true;
                                }
                            } else {
                                for (let j = 0; j < $self.filters[filterKey].length; j++) {
                                    let splittedTag = $self.filters[filterKey][j].split($self.shoeSizeSeparator);
                                    let currentSizeMapping = $self.sizeMappingMetafield.find(sizeMapping => sizeMapping.id == parseInt(product.sizeMappingId));

                                    if (currentSizeMapping && formattedFilterData) {
                                        let sizeMappingRows = currentSizeMapping.size.filter(size => size[splittedTag[1]].toString().toLowerCase() == splittedTag[0].toLowerCase());

                                        if (sizeMappingRows.length > 0) {
                                            for (let x = 0; x < sizeMappingRows.length; x++) {
                                                for (const [key, value] of Object.entries(sizeMappingRows[x])) {
                                                    if ((key == splittedTag[1] && product.filterData[filterKey].includes(value.toLowerCase())) || (key == product.defaultSizeScale && product.filterData[filterKey].includes(value.toLowerCase()))) {
                                                        testFilters[filterKey] = true;
                                                    }
                                                }
                                            }
                                        }
                                    } else if (product.defaultSizeScale) {
                                        let defaultSizeScale = product.defaultSizeScale.toLowerCase();

                                        if (formattedFilterData && defaultSizeScale == splittedTag[1] && formattedFilterData.includes(handleize(splittedTag[0]))) {
                                            testFilters[filterKey] = true;
                                        }
                                    }
                                }
                            }
                        } else {
                            testFilters[filterKey] = true;
                        }
                    });

                    let formattedFilterData = product.filterData[initialFilterType] ? product.filterData[initialFilterType].map(tag => handleize(tag)) : null;

                    if (Object.keys(testFilters).filter(key => testFilters[key] == true).length == Object.keys($self.filters).length &&
                        initialFilterType != $self.shoesizeType)
                    {
                        let tags = formattedFilterData ? formattedFilterData.filter(element => filterTypeTags.includes(element)) : [];

                        tags.map(function(tag) {
                            let index = $self.initialFiltersTag[initialFilterType].findIndex(initialFilterTag => handleize(initialFilterTag.tag) == tag);

                            if (index >= 0) {
                                $self.initialFiltersTag[initialFilterType][index].disabled = false;
                            }
                        });
                    } else if (Object.keys(testFilters).filter(key => testFilters[key] == true).length == Object.keys($self.filters).length && formattedFilterData) {
                        if (product.sizeMappingId) {
                            let currentSizeMapping = $self.sizeMappingMetafield.find(sizeMapping => sizeMapping.id == parseInt(product.sizeMappingId));

                            if (currentSizeMapping) {
                                for (let j = 0; j < formattedFilterData.length; j++) {
                                    let sizeMappingRows = currentSizeMapping.size.filter(size => handleize(size[product.defaultSizeScale].toString().toLowerCase()) == formattedFilterData[j].toLowerCase());

                                    if (sizeMappingRows) {
                                        for (let x = 0; x < sizeMappingRows.length; x++) {
                                            for (const [key, value] of Object.entries(sizeMappingRows[x])) {
                                                let sizeIndex = $self.sizeMapping[key] ? $self.sizeMapping[key].findIndex(size => size.size ? size.size.toString().toLowerCase() == value.toString().toLowerCase() : false) : -1;

                                                if (sizeIndex >= 0 && $self.sizeMapping[key][sizeIndex]) {
                                                    $self.sizeMapping[key][sizeIndex].disabled = false;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else if (product.defaultSizeScale) {
                            let defaultSizeScale = product.defaultSizeScale.toLowerCase();
                            let tags = formattedFilterData ? formattedFilterData.filter(element => filterTypeTags.includes(element)) : [];

                            tags.map(function(tag) {
                                let sizeIndex = $self.sizeMapping[defaultSizeScale] ? $self.sizeMapping[defaultSizeScale].findIndex(size => size.size ? handleize(size.size.toString().toLowerCase()) == tag.toString().toLowerCase() : false) : -1;

                                if (sizeIndex >= 0) {
                                    $self.sizeMapping[defaultSizeScale][sizeIndex].disabled = false;
                                }
                            });
                        }
                    }
                }
            });
        } else {
            Object.keys(this.initialFiltersTag).map(function(initialFilterType) {
                for (let i = 0; i < $self.initialFiltersTag[initialFilterType].length; i++) {
                    $self.initialFiltersTag[initialFilterType][i].disabled = false;
                }
            });

            Object.keys(this.sizeMapping).map(function(key) {
                for (let i = 0; i < $self.sizeMapping[key].length; i++) {
                    if($self.sizeMapping[key][i].disabled) {
                        $self.sizeMapping[key][i].disabled = false;
                    }
                }
            });

            this.firstFilterType = false;
        }
    }

    updateFilterObject(type, name, updateFromClick = false) {
        // I filtri department e macroCategory sono monochoice
        const departmentSetting = Shopfilters.settings.categoryFilter.department;
        const macroCategorySetting = Shopfilters.settings.categoryFilter.macroCategory;
        const microCategorySetting = Shopfilters.settings.categoryFilter.microCategory;

        if (type == departmentSetting || type == macroCategorySetting || type == microCategorySetting) {

            // Non faccio un push (come andrebbe fatto di default), ma un assegnazione, così da forzare il mono-choice
            if (this.filters[type].includes(name)) {
                this.filters[type] = [];
            } else {
                this.filters[type] = [name];
            }
            if (type == departmentSetting) {
                this.filters[macroCategorySetting] = [];
            }
            if (type == departmentSetting || type == macroCategorySetting) {
                this.filters[microCategorySetting] = [];
            }
        } else {
            if (this.filters[type].includes(name)) {
                this.filters[type] = this.filters[type].filter(filterValue => filterValue !== name);
            } else {
                this.filters[type].push(name);
            }
        }

        if (updateFromClick) {
            if (type == macroCategorySetting && this.filters[type].length > 0) {
                // Forzo l'apertura del filtro micro se le micro esistono
                this.currentFilterType = microCategorySetting;
            }
        }

        // Aggiorno firstFilterType
        if (!this.firstFilterType) {
            this.firstFilterType = type;
            localStorage.setItem('filter-first', type);
        }
    }

    // Gestione del click di un filtro
    handleFilterLinkClick(link) {
        let filterType = link.dataset.filterType + '';
        let filterValue = link.dataset.filterValue + '';

        // Resetto pagination, currentPage e filteredProducts
        this.currentPage = 1;
        this.pagination = 1;
        this.filteredProducts = [];
        this.filteredProductsPages = [];

        // aggiorno l'oggetto dei filtri
        this.updateFilterObject(filterType, filterValue, true);

        // Aggiorno url
        this.updateQueryParams();

        // Eseguo logica filtri
        this.executeFilters();
    }

    clearFilters() {
        let $self = this;

        // Resetto pagination, currentPage e filteredProducts
        this.currentPage = parseInt(getUrlParameter('page')) ? this.currentPage = parseInt(getUrlParameter('page')) : 1;
        this.pagination = 1;
        this.filteredProducts = [];
        this.filteredProductsPages = [];
        localStorage.setItem('filter-first', false);
        localStorage.setItem('filter-last', false);

        // Resetto i filtri
        Object.keys(this.filters).map(function(filterType) {
            $self.filters[filterType] = [];
        });

        // Aggiorno url
        this.updateQueryParams();

        // Eseguo logica filtri
        this.executeFilters();
    }

    // Conto i filtri attivi
    countActiveFilters() {
        let $self = this;

        return Object.keys(this.filters).reduce(function(filter, index) {
            return filter.concat($self.filters[index])
        }, []).length
    };

    // Aggiungo i prodotti a frontend
    fetchPages() {

        while (this.currentPage <= this.filterMaxPages + 1 && this.pages[this.currentPage]) {
            for (let i = 0; i < this.pages[this.currentPage].length; i++) {
                this.filteredProducts.push(this.pages[this.currentPage][i]);
            }

            this.currentPage = this.currentPage + 1;
        }

        this.impaginaFiltrati();
    }

    /* divide i prodotti filtrati in pagine e poi ricostruisce la paginazione */
    impaginaFiltrati(){
        var page                         = 0;
        var product_number               = 0;
        this.filteredProductsPages       = []
        this.filteredProductsPages[page] = [];

        for (let i = 0; i < this.filteredProducts.length; i++) {
            if(product_number >= this.perPage){
                product_number = 0;
                page = page + 1;
                this.filteredProductsPages[page] = [];
            }
            this.filteredProductsPages[page].push(this.filteredProducts[i]);
            product_number = product_number + 1;
        }

        this.updatePagination();
    }

    // Gestisco la ricerca filtrando i brand a seconda del testo inserito nell'input del filtro brand
    handleBrandSearch() {
        const brandFilterList = document.querySelectorAll('.filter-type--brand .filter-type__container .filter-type__list li');

        for (var i = 0; i < brandFilterList.length; i++) {
            const span = brandFilterList[i].getElementsByTagName('span')[0];

            if (span.innerHTML.toLowerCase().indexOf(this.searchBrand) > -1) {
                brandFilterList[i].style.display = '';
            } else {
                brandFilterList[i].style.display = 'none';
            }
        }
    }

    /**
     * Sort logic
     */

    executeSort() {
        this.sortProducts();

        // Resetto pagination, currentPage e filteredProducts
        this.currentPage           = parseInt(getUrlParameter('page')) ? this.currentPage = parseInt(getUrlParameter('page')) : 1;
        this.pagination            = 1;
        this.filteredProducts      = [];
        this.filteredProductsPages = [];

        // Aggiorno url
        this.updateQueryParams();

        // esecuizione della logica di filtraggio
        this.executeFilters();
    }

    sortFilters() {
        let $self = this;

        let clothingSizesArray = [];
        let clothingSizesGrouped = {};

        let accessorySizesArray = [];
        let accessorySizesGrouped = {};
        let notMapped = []; // Array delle taglie trovate nei tag, ma non mappate nel customize. Le taglie non mappate vengono stampate dopo tutte le altre mappate

        let priceRangeArray = [];
        let priceRangeGrouped = {};

        // Gestione separazione filtri abbigliamento. Splitto per '|' e prendo tutte le scale taglie mappate per l'abbigliamento inserite nel customize
        let rangesClothing = $self.sizesRangeClothing.split('|');

        // Per ogni scala taglia, mi salvo tutte le singole taglie. Ci fornirà anche l'ordinamento da mostrare a frontend
        rangesClothing.forEach(function (rangeClothing) {
            let limits = rangeClothing.split(',');

            clothingSizesArray.push(limits);
        });

        // Gestione separazione filtri accessori. Splitto per '|' e prendo tutte le scale taglie mappate per gli accessori inserite nel customize
        let rangesAccessory = $self.sizesRangeAccessory.split('|');

        // Per ogni scala taglia, mi salvo tutte le singole taglie. Ci fornirà anche l'ordinamento da mostrare a frontend
        rangesAccessory.forEach(function (rangeAccessory) {
            let limits = rangeAccessory.split(',');

            accessorySizesArray.push(limits);
        });

        let rangesPrice = $self.priceRanges.split('|');

        // Per ogni scala taglia, mi salvo tutte le singole taglie. Ci fornirà anche l'ordinamento da mostrare a frontend
        rangesPrice.forEach(function (rangePrice) {
            let limits = rangePrice.split(',');

            priceRangeArray.push(limits);
        });

        // Mi ciclo tutti le tipologie di filtri
        Object.keys(this.initialFiltersTag).map(function(initialFilterType) {
            notMapped = [];

            if (initialFilterType == $self.clothingsizeType) {
                // Creo un raggruppamento per scala taglia di tutte le taglie mappate
                clothingSizesArray.forEach(function (clothingSizeArray, index) {
                    clothingSizesGrouped[index] = [];

                    clothingSizeArray.forEach(function(clothingSize) {
                        // Se trovo la taglia nei tag dei prodotti, associo alla taglia un gruppo (che mi servirà per capire quando mostrare la linea di separazione per le scale taglia a frontend)
                        let item = $self.initialFiltersTag[initialFilterType].find(initialFilter => initialFilter.tag.toLowerCase() == clothingSize.toLowerCase());

                        if (item) {
                            item.group = index;
                            clothingSizesGrouped[index].push(item);
                        }
                    });
                });

                // Cerco le taglie non mappate, considerando i tag dei prodotti e il raggruppamento appena creato.
                // Quindi se non trovo una delle taglie che sono nei filtri nel raggruppamento, è non mappata.
                $self.initialFiltersTag[initialFilterType].forEach(function (initialClothingSize) {
                    let found = false;

                    Object.keys(clothingSizesGrouped).map(function(index) {
                        // Evito di mettere più volte la stessa taglia non mappata
                        if (clothingSizesGrouped[index].findIndex(clothingSizeGrouped => clothingSizeGrouped.tag.toLowerCase() == initialClothingSize.tag.toLowerCase()) >= 0 &&
                            notMapped.findIndex(notMappedItem => notMappedItem.tag.toLowerCase() == initialClothingSize.tag.toLowerCase()) == -1) {
                            found = true;
                        }
                    });

                    if(!found) {
                        initialClothingSize.group = 'not-mapped';
                        notMapped.push(initialClothingSize);
                    }
                });

                $self.initialFiltersTag[initialFilterType] = [];

                // Il raggruppamento è concluso e ora posso mettere nei tag iniziali le taglie ordinate dopo il raggruppamento
                Object.keys(clothingSizesGrouped).map(function(index) {
                    $self.initialFiltersTag[initialFilterType] = $self.initialFiltersTag[initialFilterType].concat(clothingSizesGrouped[index]);
                });

                // E in fondo allego le taglie non mappate
                $self.initialFiltersTag[initialFilterType] = $self.initialFiltersTag[initialFilterType].concat(notMapped);
            } else if (initialFilterType == $self.accessorysizeType) {
                // Vedere il funzionamento per l'ordinamento delle taglie calzature
                accessorySizesArray.forEach(function (accessorySizeArray, index) {
                    accessorySizesGrouped[index] = [];

                    accessorySizeArray.forEach(function(accessorySize) {
                        let item = $self.initialFiltersTag[initialFilterType].find(initialFilter => initialFilter.tag.toLowerCase() == accessorySize.toLowerCase());

                        if(item) {
                            item.group = index;
                            accessorySizesGrouped[index].push(item);
                        }
                    });
                });

                $self.initialFiltersTag[initialFilterType].forEach(function (initialAccessorySize) {
                    let found = false;

                    Object.keys(accessorySizesGrouped).map(function(index) {
                        if(accessorySizesGrouped[index].findIndex(accessorySizeGrouped => accessorySizeGrouped.tag.toLowerCase() == initialAccessorySize.tag.toLowerCase()) >= 0 && notMapped.findIndex(notMappedItem => notMappedItem.tag.toLowerCase() == initialAccessorySize.tag.toLowerCase()) == -1) {
                            found = true;
                        }
                    });

                    if(!found) {
                        initialAccessorySize.group = 'not-mapped';
                        notMapped.push(initialAccessorySize);
                    }
                });

                $self.initialFiltersTag[initialFilterType] = [];

                Object.keys(accessorySizesGrouped).map(function(index) {
                    $self.initialFiltersTag[initialFilterType] = $self.initialFiltersTag[initialFilterType].concat(accessorySizesGrouped[index]);
                });

                $self.initialFiltersTag[initialFilterType] = $self.initialFiltersTag[initialFilterType].concat(notMapped);
            } else if (initialFilterType == $self.priceType) {
                // Vedere il funzionamento per l'ordinamento delle taglie calzature
                priceRangeArray.forEach(function (priceRangeArray, index) {
                    priceRangeGrouped[index] = [];

                    priceRangeArray.forEach(function(priceRange) {
                        let item = $self.initialFiltersTag[initialFilterType].find(initialFilter => initialFilter.tag.toLowerCase() == priceRange.toLowerCase());

                        if(item) {
                            item.group = index;
                            priceRangeGrouped[index].push(item);
                        }
                    });
                });

                $self.initialFiltersTag[initialFilterType].forEach(function (initialPriceRange) {
                    let found = false;

                    Object.keys(priceRangeGrouped).map(function(index) {
                        if (priceRangeGrouped[index].findIndex(
                            priceRangeGrouped => priceRangeGrouped.tag.toLowerCase() == initialPriceRange.tag.toLowerCase()) >= 0 &&
                            notMapped.findIndex(notMappedItem => notMappedItem.tag.toLowerCase() == initialPriceRange.tag.toLowerCase()) == -1) {
                            found = true;
                        }
                    });

                    if(!found) {
                        initialPriceRange.group = 'not-mapped';
                        notMapped.push(initialPriceRange);
                    }
                });

                $self.initialFiltersTag[initialFilterType] = [];

                Object.keys(priceRangeGrouped).map(function(index) {
                    $self.initialFiltersTag[initialFilterType] = $self.initialFiltersTag[initialFilterType].concat(priceRangeGrouped[index]);
                });

                $self.initialFiltersTag[initialFilterType] = $self.initialFiltersTag[initialFilterType].concat(notMapped);
            } else {
                // Di default, l'ordinamento a frontend dei tag è alfabetico
                $self.initialFiltersTag[initialFilterType].sort(function(a, b) {
                    let returnValue = 0;
                    const textA = a.tag.toUpperCase();
                    const textB = b.tag.toUpperCase();

                    returnValue = (textA < textB) ? -1 : (textA > textB) ? 1 : 0;

                    return returnValue;
                });
            }
        });
    }

    // Sorting a frontend delle tipologie di filtro. Il cliente può definire l'ordinamento dal customize
    sortHTMLFilters(parent) {
        let filters = document.getElementsByClassName('filter-type');

        // converte nodelist ad array
        let array = [];

        for (let i = 0; i < filters.length; i++) {
            array[i] = filters[i];
        }

        // sorting
        array.sort(function(a, b) {
            return +a.getAttribute('data-sort') - +b.getAttribute('data-sort');
        });

        let output = '';

        for (var i = 0; i < array.length; i++) {
            output += array[i].outerHTML;
        }

        let sortedHTML = `<div class="filter-types">` + output + `</div>`;
        parent.innerHTML = sortedHTML.replace(/(\r\n|\n|\r)/gm, '').replace(/\s\s+/g, ' ');
    }

    sortProducts() {
        let page = 1;

        switch (this.sorting) {
            case 'trending':
                this.products.sort(function (a, b) {
                    let returnValue = 0;

                    returnValue = a.position - b.position;

                    return returnValue;
                });
                break;
            case 'price-ascending':
                // Sorting per price asc
                this.products.sort(function(a, b) {
                    let returnValue = 0;

                    returnValue = a.price - b.price;

                    if (returnValue == 0) { // If same date sort by title ascending
                        let textA = a.handle;
                        let textB = b.handle;

                        returnValue = (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    }

                    return returnValue;
                });
                break;
            case 'price-descending':
                // Sorting per price desc
                this.products.sort(function(a, b) {
                    let returnValue = 0;

                    returnValue = b.price - a.price;

                    if (returnValue == 0) { // If same date sort by title ascending
                        let textA = a.handle;
                        let textB = b.handle;

                        returnValue = (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    }

                    return returnValue;
                });
                break;
            case 'title-ascending':
                // Sorting per title asc
                this.products.sort(function(a, b) {
                    let returnValue = 0;
                    let textA = a.title.toUpperCase();
                    let textB = b.title.toUpperCase();

                    returnValue = (textA < textB) ? -1 : (textA > textB) ? 1 : 0;

                    return returnValue;
                });
                break;
            case 'title-descending':
                // Sorting per title desc
                this.products.sort(function(a, b) {
                    let returnValue = 0;
                    let textA = a.title.toUpperCase();
                    let textB = b.title.toUpperCase();

                    returnValue = (textB < textA) ? -1 : (textB > textA) ? 1 : 0;

                    return returnValue;
                });
                break;
            case 'created-descending':
                // Sorting per date asc
                this.products.sort(function(a, b) {
                    let returnValue = 0;
                    returnValue = b.date - a.date;
                    if (returnValue == 0) { // If same date sort by title ascending
                        let textA = a.handle;
                        let textB = b.handle;

                        returnValue = (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        // returnValue = b.position - a.position;
                    }

                    return returnValue;
                });
                break;
            case 'created-ascending':
                // Sorting per date desc
                this.products.sort(function(a, b) {

                    let returnValue = 0;
                    returnValue = a.date - b.date;

                    if (returnValue == 0) { // If same date sort by title ascending
                        let textA = a.handle;
                        let textB = b.handle;

                        returnValue = (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    }

                    return returnValue;
                });
                break;
        }

        // Dopo aver ordinato i prodotti (da codice) secondo un determinato sorting, creo le pagine per il frontend con i prodotto ordinati

        this.pages = [];

        for (let i = 0; i < this.products.length; i++) {
            if (this.pages[page] != null) {
                this.pages[page].push(this.products[i]);
            } else {
            this.pages[page] = [];
               this.pages[page].push(this.products[i]);
            }

            // Quando ho concluso di riempire una pagina con i prodotti, vado 'a pagina nuova'
            if (((i + 1) % this.perPage) == 0) {
                page += 1;
            }
        }
    }

    updateQueryParams() {
        let $self = this;

        let urlParams = [];

        // Aggiorno le query params dell'url
        let filtersQueryParams = Object.keys(this.filters).map(function(key) {
            if ($self.filters[key].length > 0) {
                return $self.filterUrlPrefix + key + '=' + $self.filters[key].join(',');
            }
        }).filter(Boolean);

        urlParams = urlParams.concat(filtersQueryParams);

        // Aggiorno la query param della paginazione

        if (this.pagination > 1) {
            urlParams.push('pagination' + '=' + this.pagination);
        }

        if (getUrlParameter('page')) {
            //urlParams.push('page' + '=' + getUrlParameter('page'));
            urlParams.push('page' + '=' + '1');
        }

        if (this.pid) {
            urlParams.push('pid' + '=' + this.pid);
        }

        if (getUrlParameter('q')) {
            urlParams.push('q' + '=' + getUrlParameter('q'));
        }

        if (getUrlParameter('type')) {
            urlParams.push('type' + '=' + getUrlParameter('type'));
        }

        if (this.sorting) {
            urlParams.push('custom-sort-by' + '=' + this.sorting);
        }

        // Aggiorno query params nell'url
        history.replaceState(null, null, window.location.href.split('?')[0] + '?' + urlParams.join('&'));
    }

    /**
     * Event handler
     */

    initEventHandlers() {
        let $self = this;
        $self.mql = window.matchMedia('(max-width: 1024px)');
        // Fix for Safari bfcache (back-forward cache, round-trip cache)
        window.addEventListener('pageshow', function (e) {
            if(e.persisted) {
                $self.dispatchEvent('onInitEnded');
            }
        });
        // Quando l'init è concluso
        window.addEventListener(this.namespace + '-' + 'onInitEnded', function(event) {
            let showArticlesSelectors = document.querySelectorAll($self.showArticlesSelector);

            if(Shopfilters.settings.isSearch) {
                if ($self.articles.length > 0) {
                    $self.printArticlesListing();

                    for (let i = 0; i < showArticlesSelectors.length; i++) {
                        showArticlesSelectors[i].style.display = 'block';
                    }
                }
            }

            checkPid();
        });

        document.addEventListener('click', function (event) {
            // Evento onClick di un titolo di un filtro
            if (event.target.matches($self.filterTypeTitleSelector)) {
                event.preventDefault();
                $self.handleFilterTitle(event.target);
            };

            // Evento onClick di un filtro
            if (event.target.matches($self.filterLinkSelector)) {
                event.preventDefault();
                event.target.classList.add('active');

                showLoader();

                // mettere un setTimeout se si vuole mostrare per qualche millesimo di secondo il loader
                setTimeout(function () {
                    // mettere un setTimeout se si vuole mostrare per qualche millesimo di secondo il loader
                    $self.handleFilterLinkClick(event.target);
                    if ($self.mql.matches) {
                        if($self.countActiveFilters() > 0){
                            document.querySelector('.filter__close .label').innerHTML = Shopfilters.settings.translations.closeApply;
                        } else {
                            document.querySelector('.filter__close .label').innerHTML = Shopfilters.settings.translations.close;
                        }
                    }
                 }, 800);

                document.querySelector('details[open] .filter__content').classList.add('selected');
                document.querySelector('.filter__actions').classList.add('selected');

            }

            // CUSTOM D1 -Evento onClick di una sort option
            if (event.target.matches('.sorting__link')) {
                event.preventDefault();
                const link = event.target;
                $self.sorting = link.dataset.value + '';
                document.querySelectorAll('.sorting__link').forEach(element => element.classList.remove('active'));
                link.classList.add('active');
                $self.executeSort();

                if ($self.mql.matches) {
                    document.querySelector('.filter__close .label').innerHTML = Shopfilters.settings.translations.closeApply;
                }

                document.querySelector('details[open] .filter__content').classList.add('selected');
                document.querySelector('.filter__actions').classList.add('selected');
            }

            // Evento onClick del load-more
            if (Shopfilters.settings.loadMore) {
                if (event.target.matches($self.loadMoreSelector)) {
                    event.preventDefault();
                    showLoader();

                    if ($self.pagination <= $self.currentPage) {
                        $self.pagination = $self.pagination + 1;

                        $self.updateQueryParams();
                        // $self.printProductsListing('load-more');
                        $self.printProductsListing('pagination');
                    }

                    hideLoader();
                }
            }

            // Evento onClick del clear all filters
            if (event.target.matches($self.clearFiltersSelector)) {
                event.preventDefault();

                $self.clearFilters();

                document.querySelector('.filter__actions').classList.remove('selected','applied');
                document.querySelector('details .filter__content').classList.remove('selected');
                document.querySelector('.filter__close .label').innerHTML = Shopfilters.settings.translations.close;
            }

            // Evento onClick switch view search
            if (event.target.matches($self.showProductsSelector)) {
                event.preventDefault();

                $self.handleHiglight('products');
            }

            if (event.target.matches($self.showArticlesSelector)) {
                event.preventDefault();

                $self.handleHiglight('articles');
            }

            if (event.target.matches('.filter__apply')) {
                document.querySelector('.filter__container details').removeAttribute('open');
                event.target.parentNode.classList.add('applied');
            }

            if (document.querySelector('details[open] .filter__title') && document.querySelector('details[open] .filter__title').contains(event.target)) {
                document.querySelector('.filter__container details').setAttribute('open', false);
                document.querySelector('.filter__apply').parentNode.classList.add('applied');
            }

            if (event.target.matches('.filter__reset')) {
                event.target.parentNode.classList.remove('applied', 'selected');
                document.querySelector('details[open] .filter__content').classList.remove('selected');
                $self.clearFilters();
                document.querySelector('.filter__container details').removeAttribute('open');
            }

        }, false);

        document.addEventListener('change', function(event) {
            // Evento onChange della select per il sort
            if (event.target.matches($self.sortBySelector)) {
                event.preventDefault();
                let sortByElement = document.querySelector(this.sortBySelector);
                $self.sorting = sortByElement.value;
                $self.executeSort();
            }
        }, false);
    }

    /**
     * Custom Events
     */

    customInitEventHandlers() {
        let $self = this;

        window.addEventListener(this.namespace + '-' + 'onInit', function(event) {
            showLoader();
        });

        // Quando l'init è concluso
        window.addEventListener(this.namespace + '-' + 'onInitEnded', function(event) {
            document.body.classList.add('is-loaded');
            hideLoader();
        });

        window.addEventListener(this.namespace + '-' + 'onFiltersUpdating', function(event) {
            showLoader();
        });

        window.addEventListener(this.namespace + '-' + 'onProductsFetched', function(event) {
            // sorting dell'oggetto per il filtro category
            $self.filtersCategoryHierarchical = sortObjKeysAlphabetically($self.filtersCategoryHierarchical);

            // init del size mapping
            $self.initSizeMapping();
        });

        // Quando devo aggiornare l'html dei filtri e dei prodotti
        window.addEventListener(this.namespace + '-' + 'onFiltersUpdated', function(event) {
            $self.printProductsListing('reset');
            $self.printCurrentFilters();
            $self.printFilters();
            $self.printTotalProducts();
            hideLoader();
            // $self.closeFilters();
        });

        // Quando clicco sulla product card di un prodotto
        document.body.addEventListener('click', function(event) {
            let productCardElements = document.querySelectorAll($self.productCardSelector);

            productCardElements.forEach(function(element, index) {
                if (element.contains(event.target)) {

                    let queryString = window.location.search;
                    let baseUrl = window.location.href.split('?')[0];
                    let urlParams = new URLSearchParams(queryString);

                    // Se trovo l'id del prodotto, lo salvo prima di andare alla scheda prodotto così posso riportare l'utente nella stessa posizione in cui si trovava prima di andare nella PDP
                    $self.pid = event.target.closest($self.productCardSelector).dataset.productId ? event.target.closest($self.productCardSelector).dataset.productId : false;

                    if ($self.pid) {
                        if (urlParams.has('pid')) {
                            urlParams.delete('pid');
                        }

                        urlParams.append('pid', $self.pid);

                        let newUrl = baseUrl + '?' + urlParams.toString();

                        history.replaceState(null, null, newUrl);
                    }
                }
            });
        }, false);

        // Size mapping events
        document.addEventListener('click', function(event) {
            let filterWrapperElement = null;

            // if (Shopfilters.isMobile(1200)) {
            //    filterWrapperElement = document.querySelector($self.filterWrappersMobile);
            // } else {
                filterWrapperElement = document.querySelector($self.filterWrappers);
            //}

            if (event.target.matches($self.sizeMappingFakeSelectSelectorTrigger)) {
                event.preventDefault();

                filterWrapperElement.classList.toggle($self.sizeMappingSelectOpenClass);
            } else {
                filterWrapperElement.classList.remove($self.sizeMappingSelectOpenClass);
            }

            if (event.target.matches($self.sizeMappingFakeOptionSelector)) {
                event.preventDefault();

                let value = event.target.dataset.value;
                let sizeMappingSelectElement = document.querySelector($self.sizeMappingSelectSelector);

                $self.selectedSizeMapping = value;
                sizeMappingSelectElement.value = value;
                sizeMappingSelectElement.dispatchEvent(new Event('change'));

                filterWrapperElement.classList.remove($self.sizeMappingSelectOpenClass);

                // quando cambio scala taglia, riporto lo scroll del div a 0 per comodità dell'utente
                document.querySelectorAll('.filter-type__container.open .filter-type__list')[0].scrollTop = 0;

                $self.printFilters();
            }
        }, false);

        // input box nel filtro brand, quando scrivi filtra i valori in base alla parola ricercata
        document.addEventListener('input', function(event) {
            if (event.target.matches($self.searchBrandSelector)) {
                event.preventDefault();
                $self.searchBrand = event.target.value;

                $self.handleBrandSearch();
            }
        });
    }

    /**
     * Size mapping functions
     */

    initSizeMapping() {
        let $self = this;

        // calcolo l'oggetto sizeMapping considerando tutti i prodotti nella collection/search
        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].sizeMappingId) {
                let currentMapping = this.sizeMappingMetafield.find(sizeMapping => sizeMapping.id == parseInt(this.products[i].sizeMappingId));
                // se effettivamente esiste il sizeMapping indicato nel tag, costruisco l'oggetto
                if (currentMapping) {
                    let currentSizeMapping = currentMapping.size;
                    let productDefaultSizeScale = currentMapping.default_size_scale.toLowerCase();
                    let productShoeSizes = this.products[i].filterData[$self.shoesizeType] ? this.products[i].filterData[$self.shoesizeType] : [];

                    // Ora che so quali taglie calzature sono disponibili per il prodotto, aggiungo all'oggetto sizeMapping le taglie del prodotto mappate per ogni scala taglia
                    for (let j = 0; j < productShoeSizes.length; j++) {
                        // è possibile avere più corrispondenze nel mapping per la stessa taglia, quindi non posso usare find ma devo usare filter
                        let sizeMappingRow = currentSizeMapping.filter(size => size[productDefaultSizeScale].toString().toLowerCase() == productShoeSizes[j].toString().toLowerCase());

                        if (sizeMappingRow.length > 0) {
                            for (let x = 0; x < sizeMappingRow.length; x++) {
                                for (const [key, value] of Object.entries(sizeMappingRow[x])) {
                                    if (!this.sizeMapping[key]) {
                                        this.sizeMapping[key] = [];
                                    }

                                    // Evito di pushare i doppioni
                                    if (!this.sizeMapping[key].includes(value.toString())) {
                                        this.sizeMapping[key].push(value.toString());
                                    }
                                }
                            }
                        }
                    }
                }
            } else if (this.products[i].defaultSizeScale && this.products[i].filterData[this.shoesizeType]) {
                const defaultSizeScale = this.products[i].defaultSizeScale.toLowerCase();

                this.products[i].filterData[this.shoesizeType].map(function (filterTag, index) {
                    if (!$self.sizeMapping[defaultSizeScale]) {
                        $self.sizeMapping[defaultSizeScale] = [];
                    }

                    // Evito di pushare i doppioni
                    if (!$self.sizeMapping[defaultSizeScale].includes(filterTag.toString())) {
                        $self.sizeMapping[defaultSizeScale].push(filterTag.toString());
                    }
                });
            }
        }

        // in questa fase devo ordinare l'oggetto sizeMapping seguendo le schiere taglie inserite nel customize
        let shoeSizesObject = {};
        let notMapped = {};

        //Gestione separazione filtri scarpe
        let rangesSize = $self.sizesRangeShoe.split('|');

        if (rangesSize.length > 0 && rangesSize[0] != '') {
            rangesSize.forEach(function (rangeSize) {
                // splitto per la stringa '=' per avere una referenza per ogni scala taglia.
                // Es: uk=1,1.5,2, splittando per '=' ho il riferimento alla scala taglia (uk) e alle taglie che la compongono (1,1.5,2).
                // in questo modo so come devo ordinare i filtri per ogni scala taglia
                // Purtroppo esistono calzature con taglie internazionali (XS,S,M etc...) e per gestirle si è pensato di aggiungere alla fine di ogni altra schiera,
                // tutte le taglie internazionli presenti nella collection

                let rangesSizeSplitted = rangeSize.split('=');
                shoeSizesObject[rangesSizeSplitted[0]] = [];
                let totalShoeScale = [];

                if(rangesSizeSplitted[1]) {
                    let limits = rangesSizeSplitted[1].split('&');


                    limits.forEach(function (shoeScale, index) {
                        let currentShoeScale = shoeScale.split(',');

                        currentShoeScale.forEach(function (shoeSize) {
                            let shoe = {};

                            shoe.size = shoeSize;
                            shoe.group = index;
                            shoe.disabled = false;

                            totalShoeScale.push(shoe);
                        });
                    });
                }

                shoeSizesObject[rangesSizeSplitted[0]] = totalShoeScale;
            });
        }

        // effettivo ordinamento dell'oggetto sizeMapping secondo le schiere indicate nel customize.
        // Segue in parte la logica dell'ordinamento di taglie abbigliamento e accessori
        Object.keys(this.sizeMapping).forEach(function (shoeSizeKey, index) {
            if (shoeSizesObject[shoeSizeKey]) {
                // per prima cosa tolgo i filtri non mappati nelle schiera che sto analizzando e li metto in un array
                let filteredSize = [];

                $self.sizeMapping[shoeSizeKey].map((element, index) => {
                    let size = shoeSizesObject[shoeSizeKey].find(size => size.size.toLowerCase() == element.toLowerCase());

                    if(!size) {
                        if(!notMapped[shoeSizeKey]) {
                            notMapped[shoeSizeKey] = [];
                        }

                        notMapped[shoeSizeKey].push({
                            group: 'not-mapped',
                            size: element,
                            disabled: false
                        });

                        return false;
                    }

                    filteredSize.push(size);
                });

                $self.sizeMapping[shoeSizeKey] = filteredSize;

                // ordinamento
                $self.sizeMapping[shoeSizeKey].sort(function (a, b) {
                    return shoeSizesObject[shoeSizeKey].findIndex(size => size.size == a.size) - shoeSizesObject[shoeSizeKey].findIndex(size => size.size == b.size);
                });

                // accodo alla schiera taglia attuale le taglie non mappate
                if (notMapped[shoeSizeKey] && notMapped[shoeSizeKey].length > 0) {
                    $self.sizeMapping[shoeSizeKey] = $self.sizeMapping[shoeSizeKey].concat(notMapped[shoeSizeKey]);
                }
            }
        });

        // controllo se ci sono taglie footwear nell'url e prendo l'ultima selezionata dall'utente, in modo tale da preselezionarne la scala taglia di riferimento nella select
        const filterSizeFootwear = getUrlParameter('filters-size-footwear');

        if (filterSizeFootwear) {
            let footwearSizes = filterSizeFootwear.split(',');
            let lastSize = '';

            if (Array.isArray(footwearSizes)) {
                lastSize = footwearSizes.slice(-1)[0];
            } else {
                lastSize = footwearSizes;
            }

            this.selectedSizeMapping = lastSize.split($self.shoeSizeSeparator)[1];
        }
    }

    /**
     * Customable render function
     */

    printTotalProducts() {
        let totalProductsElement = document.querySelector(this.totalProductsSelector);
        let totalProductsElementMobile = document.querySelector(this.totalProductsSelectorMobile);
        let count = this.filteredProducts.length > 1 ? Shopfilters.settings.translations.countProducts.replace('$count', this.filteredProducts.length) : Shopfilters.settings.translations.countProduct;
        if(totalProductsElement)
            totalProductsElement.innerHTML = count;
        if(totalProductsElementMobile)
            totalProductsElementMobile.innerHTML = count;
    }

    printProductsListing(printType) {
        // Controllo se ci sono troppi prodotti visualizzati. In caso ci fossero li nascondo
        let shift = (this.filteredProducts.length - (this.perPage * this.pagination) > 0) ? this.filteredProducts.length - (this.perPage * this.pagination) : 0;
        let productListingElement = document.querySelector(this.productsListingSelector);
        let i;

        if (this.filteredProducts.length == 0) {
            // Gestione not found
            productListingElement.classList.add('empty');
            productListingElement.innerHTML = Shopfilters.settings.translations.noProducts;
            // @TODO: review no products found
            hideLoadMore();
        } else {
            // Se non sto usando il load more resetto l'html del div contenente i prodotti e resetto la variabile in cui mantengo l'indice dell'ultimo prodotto stampato
            let productsToPrint = this.filteredProducts;
            if (printType != 'load-more') {
                this.lastProductPrinted         = 0;                                         // dato inutile in caso di paginazione
                shift                           = 0;                                         // Da resettare in caso di paginazione
                productListingElement.innerHTML = '';                                        // Svuotiamo il contenitore dei prodotti
                if(this.filteredProductsPages[(this.requestedPage - 1)]){
                    productsToPrint = this.filteredProductsPages[(this.requestedPage - 1)];  // Scegliamo la pagina corretta da pubblicare nell'array delle pagine
                }
            }

            var ecommerceItems = [];
            for (i = this.lastProductPrinted; i < (productsToPrint.length - shift); i++) {
                productListingElement.innerHTML += productsToPrint[i].html;
                const productGtmData = JSON.parse(productsToPrint[i].gtm)

                let productData = {
                    "item_id"          : productGtmData.gtmItemId,
                    "item_name"        : productGtmData.gtmTitle,
                    "item_variant"     : productGtmData.gtmItemVariant,
                    "item_brand"       : productGtmData.gtmItemBrand,
                    "item_category"    : productGtmData.gtmItemCategory,
                    "item_category_2"  : productGtmData.gtmItemCategory_2,
                    "item_category_3"  : productGtmData.gtmItemCategory_3,
                    "item_category_4"  : productGtmData.gtmItemCategory_4,
                    "item_list_name"   : productGtmData.gtmItemListName,
                    "item_list_id"     : productGtmData.gtmItemListName,
                    "price"            : productGtmData.gtmPrice,
                    "currency"         : productGtmData.gtmCurrency,
                    "index"            : productGtmData.gtmIndex,
                    "imageURL"         : productGtmData.gtmImageUrl,
                    "productURL"       : productGtmData.gtmProductURL,
                    "color"            : productGtmData.gtmColor,
                    "sku"              : productGtmData.gtmSku,
                    "page"             : productGtmData.gtmPage,
                }

                ecommerceItems.push(productData);
            }

            let gtmEvent = new CustomEvent("gtmUpdateDataLayer", { 'detail': ecommerceItems });
            document.dispatchEvent(gtmEvent);

            // Salvo indice dell'ultimo prodotto stampato
            this.lastProductPrinted = i;

            if (printType != 'load-more') {
                // Se sono arrivato all'ultima pagina, nascondo il load-more
                if (productsToPrint.length == productsToPrint.length - shift) {
                    hideLoadMore();
                } else {
                    showLoadMore();
                }
            }
            // Reload smartWishlist
            if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();

            // Ordinamento delle taglie nel product card
            sortSize('.product-form__variant', '.product-form__variants', '.card-wrapper');
        }
    }

    printArticlesListing() {
        let articlesMarkup = '<div class="blog__container">';

        this.articlesListing = document.querySelector(this.articlesListingSelector);

        for (let i = 0; i < this.articles.length; i++) {
            articlesMarkup +=
            `<div class="blog__image-container">
                <div class="blog__image">
                    <a href="${this.articles[i].url}">

                    <div class="ratio-container">
                        <img alt="" src="${this.articles[i].image}">
                    </div>

                    <div class="blog__overlay">
                        <a href="${this.articles[i].url}">
                            <h1 class="blog__title">${this.articles[i].title}</h1>
                        </a>
                        ${this.articles[i].excerpt ? `<div class="blog__excerpt">${this.articles[i].excerpt}</div>` : ''}
                        <div class="blog__date">${this.articles[i].date}</div>
                    </div>
                </div>
            </div>`;
        }

        articlesMarkup += `</div>`;

        this.articlesListing.innerHTML = articlesMarkup;
    }

    printCurrentFilters() {
        let $self = this;
        let currentFiltersElement;
        let showCurrentFilters = false; // stampo i current filters solo se trovo altri filtri oltre a 'macro category' e 'department'
        currentFiltersElement = document.querySelector(this.currentFiltersSelector);

        currentFiltersElement.innerHTML = '';

        if (this.countActiveFilters() > 0) {
            let currentFiltersMarkup = '';

            // Non stampo department e macroCategory come filtri perchè monochoice
            Object.keys(this.filters).map(function (filterType) {
                if (// filterType != Shopfilters.settings.categoryFilter.department &&
                    // filterType != Shopfilters.settings.categoryFilter.macroCategory &&
                    Object.keys($self.filters[filterType]).length > 0
                ) {
                    for (let j = 0; j < $self.filters[filterType].length; j++) {
                        let filterLabel = '';

                        if (filterType == $self.shoesizeType) {
                            let splittedTag = $self.filters[filterType][j].split($self.shoeSizeSeparator);
                            filterLabel = splittedTag.length > 1 ? `${splittedTag[0]} ${splittedTag[1]}` : `${splittedTag[0]}`;
                        } else {
                            filterLabel = $self.initialFiltersTag[filterType].find(initialFilterTag => handleize(initialFilterTag.tag) == $self.filters[filterType][j]) ? $self.initialFiltersTag[filterType].find(initialFilterTag => handleize(initialFilterTag.tag) == $self.filters[filterType][j]).tag : $self.filters[filterType][j];
                        }

                        if (filterType == "season") {
                            if(filterLabel == 'new'){
                                filterLabel = jsUcfirst(Shopfilters.settings.seasonFilter.new);
                            }
                            if(filterLabel == 'old'){
                                filterLabel = jsUcfirst(Shopfilters.settings.seasonFilter.old);
                            }
                        }

                        currentFiltersMarkup = currentFiltersMarkup +
                            `<li class="filter-option ${filterType}" data-filter-type="${filterType}" data-filter-value="${$self.filters[filterType][j]}">` +
                            `<span class="current-filter">${filterLabel}</span><span class="icon icon-close"></span></li>`;
                    }

                    showCurrentFilters = true;
                }
            });

            if (showCurrentFilters) {
                let clearFiltersMarkup = `<div class="current-filters__container">
                    <div class="current-filters__bar">
                        <div class="current-filters__selected">${Shopfilters.settings.translations.selectedLabel} <span>(${this.countActiveFilters()})</span>:</div>
                    </div>
                    <ul class="list list-horizontal list-unstyled">${currentFiltersMarkup}</ul>
                    <div class="current-filters__reset"><a id="clear-filters" class="link" href="javascript:void(0)">
                    <span>${Shopfilters.settings.translations.resetLabel}</span><span class="icon icon-close inverse"></span></a></div>
                </div>`;

                // let literalTemplate = clearFiltersMarkup;
                currentFiltersElement.innerHTML = clearFiltersMarkup;
                //currentFiltersElement.innerHTML = literalTemplate;
                if(document.querySelector('.filter__container .count-elements')) {
                    document.querySelector('.filter__container .count-elements').innerHTML = `(${this.countActiveFilters()})`;
                }
            }
        } else {
            if(document.querySelector('.filter__container .count-elements')) {
                document.querySelector('.filter__container .count-elements').innerHTML = '';
            }
        }
    }

    printFilters() {
        let $self = this;
        let filterWrapperElement;
        const departmentSetting = Shopfilters.settings.categoryFilter.department;
        const macroCategorySetting = Shopfilters.settings.categoryFilter.macroCategory;
        const microCategorySetting = Shopfilters.settings.categoryFilter.microCategory;
        const filtersDeptSelected = $self.filters[departmentSetting];
        const fitlersMacroSelected = $self.filters[macroCategorySetting];

        filterWrapperElement = document.querySelector(this.filterWrappers);

        // serve per mantenere lo scroll effettuato dentro alla dropdown attiva ad ogni aggiornamento dell'html dei filtri
        let scrollTopOpened = document.querySelectorAll('.filter-type__container.open .filter-type__list').length > 0 ? document.querySelectorAll('.filter-type__container.open .filter-type__list')[0].scrollTop : null;

        filterWrapperElement.innerHTML = '';

        let filterWrapperElementMarkup = '';

        Object.keys(this.initialFiltersTag).map(function(initialFilterType) {
            let label = $self.initialFilters.find(initialFilter => initialFilter.type == initialFilterType) ? $self.initialFilters.find(initialFilter => initialFilter.type == initialFilterType).label : '';
            let type = $self.initialFilters.find(initialFilter => initialFilter.type == initialFilterType) ? $self.initialFilters.find(initialFilter => initialFilter.type == initialFilterType).type : '';
            let position = $self.initialFilters.find(initialFilter => initialFilter.type == initialFilterType) ? $self.initialFilters.find(initialFilter => initialFilter.type == initialFilterType).position : '';

            /**
             * Il filtro category è un filtro complesso ed ha una logica molto particolare:
             *
             * Department e macro category sono filtri monochoice.
             * Se ho selezionato un filtro macro category, creo a frontend un filtro con label il nome della macro category e come filtri tutte le micro category.
             * Se entro in una collection che ha solo una micro category, il filtro category e il filtro per la micro non deve essere visualizzato.
             * Se entro in una collection che ha solo una macro category, il filtro category non viene visualizzato, ma il filtro micro si.
             * Se entro in una collection che ha solo un department, il filtro category viene visualizzato con le macro già esplose.
             *
             **/
            if (initialFilterType == 'category') {
                let department = '';
                let macroCategory = '';
                let showCategoryFilter = false;
                let hideParentFilter = false;

                if (filtersDeptSelected && filtersDeptSelected.length > 0) {
                    department = Object.keys($self.filtersCategoryHierarchical).find(department => $self.handleize(department) == filtersDeptSelected[0]); // caso con possibilità di filtro su department
                } else if (Object.keys($self.filtersCategoryHierarchical).length == 1) {
                    department = Object.keys($self.filtersCategoryHierarchical)[0]; // caso senza possibilità di filtro su department (collection create con tag macro)
                }

                if (department) {
                    if (fitlersMacroSelected.length > 0) {
                        macroCategory = Object.keys($self.filtersCategoryHierarchical[department]).find(macroCategory => $self.handleize(macroCategory) == fitlersMacroSelected[0]);  // caso con possibilità di filtro su macro
                    } else if (Object.keys($self.filtersCategoryHierarchical).length == 1 && Object.keys($self.filtersCategoryHierarchical[department]).length == 1) {
                        macroCategory = Object.keys($self.filtersCategoryHierarchical[department])[0]; // caso senza possibilità di filtro su macro (collection create con tag micro)
                    }
                }

                // Stampo il filtro 'category' solo se ho almeno più di due macro e un department
                if (Object.keys($self.filtersCategoryHierarchical).length == 1 &&
                    Object.keys($self.filtersCategoryHierarchical[Object.keys($self.filtersCategoryHierarchical)[0]]).length == 1) {
                    showCategoryFilter = true;
                    hideParentFilter = true;
                }

                if (showCategoryFilter) {
                    filterWrapperElementMarkup += `<div class="filter-type filter-type--${Shopfilters.settings.categoryFilter.department} ${fitlersMacroSelected.length > 0 || hideParentFilter ? ` disabled ` : ``}" data-sort="${position}">`;
                    let label = $self.initialFilters.find(initialFilter => initialFilter.type == initialFilterType).label;

                    filterWrapperElementMarkup +=
                        `<div class="filter-type__title ${filtersDeptSelected.length > 0 ? ` active ` : ``}" data-type="${Shopfilters.settings.categoryFilter.department}">${label}</div>
                        <div class="filter-type__container ${filtersDeptSelected.length > 0 || ($self.currentFilterType === Shopfilters.settings.categoryFilter.department
                            || ($self.currentFilterType === Shopfilters.settings.categoryFilter.macroCategory) || ($self.currentFilterType === Shopfilters.settings.categoryFilter.microCategory && $self.filtersCategoryHierarchical[department] && $self.filtersCategoryHierarchical[department][macroCategory] && $self.filtersCategoryHierarchical[department][macroCategory].length <= 1)) ? ` open ` : ``}">
                        <ul class="filter-type__list" data-scroll-lock-scrollable>`;

                    Object.keys($self.filtersCategoryHierarchical).map(function(departmentLevel, i) {
                        // Il primo livello per il filtro 'category' è DEPARTMENT
                        if (Object.keys($self.filtersCategoryHierarchical).length > 1) {
                            filterWrapperElementMarkup = filterWrapperElementMarkup + `<li class="filter-option category-filter ${filtersDeptSelected.length > 0 && filtersDeptSelected.indexOf($self.handleize(departmentLevel)) == -1 ? ` unavailable ` : ``}
                                ${Object.keys($self.filtersCategoryHierarchical[departmentLevel]).length > 0 ? ` has-submenu ` : ``}
                                ${$self.findInObjectValuesArray($self.filters, $self.handleize(departmentLevel)) ? ` active ` : ``}"
                                data-filter-type="${Shopfilters.settings.categoryFilter.department}"
                                data-filter-value="${$self.handleize(departmentLevel)}"
                                data-type="${Shopfilters.settings.categoryFilter.department}"><span class="category-filter-span">${departmentLevel}</span>`;
                            filterWrapperElementMarkup = filterWrapperElementMarkup + `<ul class="category">`;
                        }

                        // Il secondo livello per il filtro 'category' è MACRO CATEGORY
                        Object.keys($self.filtersCategoryHierarchical[departmentLevel]).map(function(macroCategoryLevel, j) {
                            filterWrapperElementMarkup = filterWrapperElementMarkup + `<li class="filter-option category-filter
                                ${$self.findInObjectValuesArray($self.filters, $self.handleize(macroCategoryLevel)) ? ` active ` : ``}"
                                data-filter-value="${$self.handleize(macroCategoryLevel)}"
                                data-type="${Shopfilters.settings.categoryFilter.macroCategory}"
                                data-filter-type="${Shopfilters.settings.categoryFilter.macroCategory}">
                                <span class="category-filter-span">${macroCategoryLevel}</span>
                            </li>`;
                        });

                        filterWrapperElementMarkup += `</ul></li>`;
                    });

                    filterWrapperElementMarkup += `</ul></div></div>`;
                }

                // Gestione per il filtro per le micro category
                if (department && macroCategory && $self.filtersCategoryHierarchical[department][macroCategory].length > 1) {
                    filterWrapperElementMarkup += `<div class="filter-type filter-type--${Shopfilters.settings.categoryFilter.microCategory}" data-sort="${position}">`;

                    filterWrapperElementMarkup +=
                        `<div class="filter-type__title" data-type="${Shopfilters.settings.categoryFilter.microCategory}">${macroCategory}</div>
                        <div class="filter-type__container ${( $self.currentFilterType === Shopfilters.settings.categoryFilter.microCategory) ? ` open ` : ``}">
                        <ul class="filter-type__list" data-scroll-lock-scrollable>`;

                    for (let i = 0; i < $self.filtersCategoryHierarchical[department][macroCategory].length; i++) {
                        // serve per capire se il filtro deve essere disabled
                        let filterTagMicro = $self.initialFiltersTag[Shopfilters.settings.categoryFilter.microCategory].find(tag => tag.tag == $self.filtersCategoryHierarchical[department][macroCategory][i]);

                        filterWrapperElementMarkup = filterWrapperElementMarkup + `<li>
                            <span class="
                                filter-option
                                ${filterTagMicro && filterTagMicro.disabled ? ` disabled ` : ``}
                                ${$self.findInObjectValuesArray($self.filters, $self.handleize($self.filtersCategoryHierarchical[department][macroCategory][i])) ? ` active ` : ``}"
                                data-filter-value="${$self.handleize($self.filtersCategoryHierarchical[department][macroCategory][i])}"
                                data-type="${Shopfilters.settings.categoryFilter.microCategory}"
                                data-filter-type="${Shopfilters.settings.categoryFilter.microCategory}"
                            >
                                    <span class="category-filter-span">${$self.filtersCategoryHierarchical[department][macroCategory][i]}</span>
                                </span>
                            </li>`;
                    }
                }

                filterWrapperElementMarkup += `</ul></div></div>`;

            } else if ($self.sizeMappingMetafield.length > 0 && initialFilterType == $self.shoesizeType) {
                // Check filter visibility
                let filtersEnabled = $self.initialFiltersTag[initialFilterType].filter(function (el) {
                return el.disabled === false
                });

                let disabled = filtersEnabled.length == 0 ? true : false;

                if(Object.values($self.filters).length > 0) {
                    disabled = false;
                }

                if (filtersDeptSelected && filtersDeptSelected.length > 0){
                    disabled = (type == $self.shoesizeType && filtersDeptSelected.indexOf('footwear') == -1) ? true : false;
                }

                if ($self.initialFiltersTag[initialFilterType].length > 1 && Object.keys($self.sizeMapping).length > 0) {
                    filterWrapperElementMarkup += `<div class="filter-type filter-type--${initialFilterType} ${ disabled ? `disabled` : ``}" data-sort="${position}">`;
                    filterWrapperElementMarkup +=
                        `<div class="filter-type__title" data-type="${type}">${label}</div>
                        <div class="filter-type__container ${( $self.currentFilterType === type) ? ` open ` : ``}">
                        `;

                    // HTML per select reale del size mapping
                    let sizeMappingOptionsMarkup = ``;

                    for (let i = 0; i < $self.sizeMappingOptions.length; i++) {
                        sizeMappingOptionsMarkup = sizeMappingOptionsMarkup +
                            `<option ${$self.selectedSizeMapping == $self.sizeMappingOptions[i].value ? `selected="selected"` : ''} value="${$self.sizeMappingOptions[i].value}">${$self.sizeMappingOptions[i].label}</option>`;
                    }

                    filterWrapperElementMarkup += `<select id="size-mapping">
                        ${sizeMappingOptionsMarkup}
                    </select>`;

                    // HTML per select fake del size mapping
                    let sizeMappingFakeOptionsMarkup = ``;
                    let sizeMappingSelectedOption = $self.sizeMappingOptions.find(sizeMappingOption => sizeMappingOption.value == $self.selectedSizeMapping);

                    for (let i = 0; i < $self.sizeMappingOptions.length; i++) {
                        sizeMappingFakeOptionsMarkup = sizeMappingFakeOptionsMarkup +
                            `${$self.sizeMapping[$self.sizeMappingOptions[i].value] && $self.sizeMapping[$self.sizeMappingOptions[i].value].length > 0 ? `<div class="size-mapping-fake__option" data-value="${$self.sizeMappingOptions[i].value}">
                                ${$self.sizeMappingOptions[i].label}
                            </div>` : ''}`;
                    }

                    filterWrapperElementMarkup += `<div class="size-mapping-fake">
                        <div class="size-mapping-fake__title">
                            <div class="size-mapping-fake__title-wrapper">
                                <span>
                                    ${sizeMappingSelectedOption.label}
                                </span>
                                <div class="size-mapping-fake__icon"></div>
                            </div>
                        </div>
                        <div class="size-mapping-fake__content">
                            ${sizeMappingFakeOptionsMarkup}
                        </div>
                    </div>`;

                    filterWrapperElementMarkup += `<ul class="filter-type__list list list-unstyled list list-horizontal" data-scroll-lock-scrollable>`;
                    if($self.sizeMapping[$self.selectedSizeMapping] && $self.sizeMapping[$self.selectedSizeMapping].length > 0) {
                        for (let i = 0; i < $self.sizeMapping[$self.selectedSizeMapping].length; i++) {
                            filterWrapperElementMarkup = filterWrapperElementMarkup + `<li>
                            <span class="filter-option ${type}
                                ${$self.sizeMapping[$self.selectedSizeMapping][i].disabled ? ` disabled ` : ``}
                                ${findInObjectValuesArray($self.filters, `${$self.sizeMapping[$self.selectedSizeMapping][i].size}$${$self.selectedSizeMapping}`) ? ` active ` : ``}"
                                data-filter-value="${$self.sizeMapping[$self.selectedSizeMapping][i].size}${$self.shoeSizeSeparator}${$self.selectedSizeMapping}" data-type="${type}" data-filter-type="${initialFilterType}">
                                ${$self.sizeMapping[$self.selectedSizeMapping][i].size}
                            </span>
                        </li>

                        ${$self.sizeMapping[$self.selectedSizeMapping][i] != undefined && i + 1 < $self.sizeMapping[$self.selectedSizeMapping].length && ($self.sizeMapping[$self.selectedSizeMapping][i].group != $self.sizeMapping[$self.selectedSizeMapping][i + 1].group) ? ` <li class="separator"></li> ` : ``}`;
                        }
                    }

                    filterWrapperElementMarkup += `</ul></div></div>`;
                }
            } else if (initialFilterType != Shopfilters.settings.categoryFilter.microCategory &&
                initialFilterType != Shopfilters.settings.categoryFilter.macroCategory &&
                initialFilterType != Shopfilters.settings.categoryFilter.department
            ) {
                if ($self.initialFiltersTag[initialFilterType].length > 0) { // NOTE: Show filter even if there is only one type in list ex. size-accessories = UN (otherwise:$self.initialFiltersTag[initialFilterType].length > 1)
                    // @TODO: review category name (clothing, accessories) is static
                    let filtersEnabled = $self.initialFiltersTag[initialFilterType].filter(function (el) {
                        return el.disabled === false
                    });
                    let disabled = filtersEnabled.length == 0 ? true : false;
                    if(filtersDeptSelected && filtersDeptSelected.length > 0) {
                        disabled = type == $self.clothingsizeType && filtersDeptSelected.indexOf('clothing') == -1 || type == $self.accessorysizeType && filtersDeptSelected.indexOf('accessories') == -1 ? true : false;
                    }
                    filterWrapperElementMarkup += `<div class="filter-type filter-type--${initialFilterType} ${ disabled ? `disabled` : ``}" data-sort="${position}">`;

                    filterWrapperElementMarkup +=
                        `<div class="filter-type__title" data-type="${type}">${label}</div>
                        <div  class="filter-type__container ${( $self.currentFilterType === type) ? ` open ` : ``}">
                        ${$self.initialFilters.find(initialFilter => initialFilter.type == initialFilterType).showSearch ? `<input value="${$self.searchBrand}" class="filter-search" type="text" placeholder="Search" style=""></input>` : ``}
                        <ul class="filter-type__list list list-unstyled">`;

                    for (let i = 0; i < $self.initialFiltersTag[initialFilterType].length; i++) { 
                        
                        let filterValue = jsUcfirst($self.initialFiltersTag[initialFilterType][i].tag);
                        if (type == "season") {
                            if($self.initialFiltersTag[initialFilterType][i].tag == 'new'){
                                filterValue = jsUcfirst(Shopfilters.settings.seasonFilter.new);
                            }
                            if($self.initialFiltersTag[initialFilterType][i].tag == 'old'){
                                filterValue = jsUcfirst(Shopfilters.settings.seasonFilter.old);
                            }
                        }

                        filterWrapperElementMarkup = filterWrapperElementMarkup +
                        `<li>
                            <span class="filter-option ${type} ${findInObjectValuesArray($self.filters, handleize($self.initialFiltersTag[initialFilterType][i].tag)) ? ` active ` : ``}
                                ${$self.initialFiltersTag[initialFilterType][i].disabled ? ` disabled ` : ``}"
                                data-filter-value="${handleize($self.initialFiltersTag[initialFilterType][i].tag)}" data-type="${type}" data-filter-type="${initialFilterType}">
                                <span class="${type == 'filter-color' ? 'color color-' + handleize($self.initialFiltersTag[initialFilterType][i].tag) : 'color-default'}"></span>
                                ${filterValue}
                            </span>
                        </li>
                        ${$self.initialFiltersTag[initialFilterType][i].group != undefined && i + 1 < $self.initialFiltersTag[initialFilterType].length && ($self.initialFiltersTag[initialFilterType][i].group != $self.initialFiltersTag[initialFilterType][i + 1].group) ? ` <li class="separator"></li> ` : ``}`;
                    }

                    filterWrapperElementMarkup += `</ul></div></div>`;
                }
            }
        });

        let literalTemplate = `<div class="filter-types">` + filterWrapperElementMarkup + `</div>`;

        filterWrapperElement.innerHTML = literalTemplate.replace(/(\r\n|\n|\r)/gm, '').replace(/\s\s+/g, ' ');

        // serve per mantenere la dropdown del filtro brand filtrata
        $self.handleBrandSearch();

        // serve per ordinare graficamente i filtri a seconda della posizione indicata nel customize
        $self.sortHTMLFilters(filterWrapperElement, scrollTopOpened);

        scrollTopOpened ? document.querySelectorAll('.filter-type__container.open .filter-type__list')[0].scrollTop = scrollTopOpened : null;
    }

    closeFilters() {
        let mql = window.matchMedia('(min-width: 990px)');
        if (mql.matches) {
            document.querySelector('.filter__container details').removeAttribute('open');
        }
    }

    // General functions

    handleFilterTitle(target) {
        let filterType         = target.dataset.type;
        let filterTypeElements = document.querySelectorAll(this.filterTypeSelector);

        for (let i = 0; i < filterTypeElements.length; i++) {
            if (filterTypeElements[i].children[0] != target) {
                filterTypeElements[i].children[0].classList.remove('active');
                filterTypeElements[i].children[1].classList.remove('open');
            }
        }

        if(target.parentNode.children[1].classList.contains('open')) {
            target.classList.remove('active');
            target.parentNode.children[1].classList.remove('open');
            this.currentFilterType = false;
        } else {
            target.classList.add('active');
            target.parentNode.children[1].classList.add('open');
            this.currentFilterType = filterType;
        }
    }

    handleHiglight(type) {
        let showArticlesSelectors    = document.querySelectorAll(this.showArticlesSelector);
        let showProductsSelectors    = document.querySelectorAll(this.showProductsSelector);
        let articlesListingContainer = document.querySelector(this.articlesListingContainerSelector);
        let productsListingContainer = document.querySelector(this.productsListingContainerSelector);
        let sortingSelectors         = document.querySelectorAll(this.sortingSelector);

        if (type == 'products') {
            showArticlesSelectors.forEach(article => article.classList.remove(this.activeClass));
            showProductsSelectors.forEach(product => product.classList.add(this.activeClass));

            productsListingContainer.classList.add(this.activeClass);
            articlesListingContainer.classList.remove(this.activeClass);
            sortingSelectors.forEach(sort => sort.style.display = 'block');
        } else {
            showArticlesSelectors.forEach(article => article.classList.add(this.activeClass));
            showProductsSelectors.forEach(product => product.classList.remove(this.activeClass));

            articlesListingContainer.classList.add(this.activeClass);
            productsListingContainer.classList.remove(this.activeClass);
            sortingSelectors.forEach(sort => sort.style.display = 'none');
        }
    }

    updatePagination(){

        const paginationWrapper = document.querySelector(this.paginationSelector);
        if(paginationWrapper){

            /*
            let actualPage = 1;
            if(getUrlParameter('page')){
                actualPage  = parseInt(getUrlParameter('page'));  // Pagina attuale
            }
            */
            if(getUrlParameter('page')){
            this.requestedPage = parseInt(getUrlParameter('page'));
            }
            let actualPage  = this.requestedPage;                 // Pagina attuale
            let pageNumbers = this.filteredProductsPages.length;  // Numero totale di pagine
            let baseUrl     = window.location.pathname;           // prendo base url
            let baseParams  = window.location.search;             // prendo params attivi da replicare

            /*
            console.log("Update pagination");
            console.log("Max pages: "      + pageNumbers);
            console.log("Pagina attuale: " + actualPage );
            console.log("Base url: "       + baseUrl);
            console.log("Search params: "  + baseParams );
            console.log(shopFilters);
            let pippo = [];
            shopFilters.filteredProducts.forEach(function (filteredProduct) {
                //console.log(filteredProduct.title, filteredProduct.position);
                pippo.push(filteredProduct.position);
            });
            console.log(pippo);
            */

            var urlParams = new URLSearchParams(baseParams);
            urlParams.delete('page'); // elimino il parametro della pagina se presente

            /* INIZIO CREAZIONE PAGINATION */
            var ul = document.createElement('ul');
            ul.setAttribute('class', 'pagination__list list-unstyled');
            ul.setAttribute('role', 'list');
            let currentTime = new Date().getTime();
            const d = new Date(currentTime);
            ul.setAttribute('data-tomeRefresh', d.toLocaleTimeString());

            /* Pagina attuale */
            if(pageNumbers > 1){
                var li = document.createElement('li');
                    var span = document.createElement('span');
                    span.setAttribute('aria-current','page');
                    span.setAttribute('class','pagination__item pagination__item--current');
                    span.setAttribute('aria-label','Pagina ' + actualPage);
                    span.innerHTML = actualPage;
                li.append(span);
                ul.append(li);
            }

            /* Pagina attuale - 1 */
            if(actualPage > 1){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    urlParams.append('page', (actualPage - 1));
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','pagination__item pagination__item--other-page link');
                    a.setAttribute('aria-label','Pagina ' + (actualPage - 1));
                    a.innerHTML = (actualPage - 1);
                li.append(a);
                ul.prepend(li);
            }

            /* Pagina attuale - 2 */
            if(actualPage > 2){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    urlParams.append('page', (actualPage - 2));
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','pagination__item pagination__item--other-page link');
                    a.setAttribute('aria-label','Pagina ' + (actualPage - 2));
                    a.innerHTML = (actualPage - 2);
                li.append(a);
                ul.prepend(li);
            }

            /* Puntini */
            /* Primo */
            if(actualPage > 4){
                var li = document.createElement('li');
                    var span = document.createElement('span');
                    span.setAttribute('class','pagination__item');
                    span.innerHTML = "...";
                li.append(span);
                ul.prepend(li);
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    urlParams.append('page', 1);
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','pagination__item pagination__item--other-page link');
                    a.setAttribute('aria-label','Pagina 1');
                    a.innerHTML = "1";
                li.append(a);
                ul.prepend(li);
            }

            /* Primo */
            if(actualPage == 4){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    urlParams.append('page', 1);
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','pagination__item pagination__item--other-page link');
                    a.setAttribute('aria-label','Pagina 1');
                    a.innerHTML = "1";
                li.append(a);
                ul.prepend(li);
            }

            /* Prev */
            if(actualPage != 1){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    urlParams.append('page', (actualPage - 1));
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','pagination__item pagination__item--next uppercase link motion-reduce');
                    a.setAttribute('aria-label','Prev');
                    a.innerHTML = "Prev";
                li.append(a);
                ul.prepend(li);
            }

            /* Pagina attuale + 1 */
            if((pageNumbers - actualPage) > 0){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    urlParams.append('page', (actualPage + 1));
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','pagination__item pagination__item--other-page link');
                    a.setAttribute('aria-label','Pagina ' + (actualPage + 1));
                    a.innerHTML = (actualPage + 1);
                li.append(a);
                ul.append(li);
            }

            /* Pagina attuale + 2 */
            if((pageNumbers - actualPage) > 1){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    urlParams.append('page', (actualPage + 2));
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','pagination__item pagination__item--other-page link');
                    a.setAttribute('aria-label','Pagina ' + (actualPage + 2));
                    a.innerHTML = (actualPage + 2);
                li.append(a);
                ul.append(li);
            }

            /* Puntini */
            /* Ultimo */
            if((pageNumbers - actualPage) > 3){
                var li = document.createElement('li');
                    var span = document.createElement('span');
                    span.setAttribute('class','pagination__item');
                    span.innerHTML = "...";
                li.append(span);
                ul.append(li);
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    urlParams.append('page', pageNumbers);
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','pagination__item pagination__item--other-page link');
                    a.setAttribute('aria-label','Pagina ' + pageNumbers);
                    a.innerHTML = pageNumbers;
                li.append(a);
                ul.append(li);
            }

            /* Ultimo */
            if((pageNumbers - actualPage) == 3){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    urlParams.append('page', pageNumbers);
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','pagination__item pagination__item--other-page link');
                    a.setAttribute('aria-label','Pagina ' + pageNumbers);
                    a.innerHTML = pageNumbers;
                li.append(a);
                ul.append(li);
            }

            /* Next */
            if(pageNumbers != actualPage){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    urlParams.append('page', (actualPage + 1));
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','pagination__item pagination__item--prev uppercase link motion-reduce');
                    a.setAttribute('aria-label','Next');
                    a.innerHTML = "Next";
                li.append(a);
                ul.append(li);
            }

            paginationWrapper.innerHTML = '';
            paginationWrapper.append(ul);
        }


    }
}

const shopFilters = new Filters();
